import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var _excluded = ["as", "className", "content", "location", "tooltip"];
var classes = {
  root: 'C-Tooltip'
};
var Tooltip = function Tooltip(props) {
  var _props$as = props.as,
    As = _props$as === void 0 ? 'span' : _props$as,
    className = props.className,
    content = props.content,
    _props$location = props.location,
    location = _props$location === void 0 ? 'none' : _props$location,
    tooltip = props.tooltip,
    otherProps = _objectWithoutProperties(props, _excluded);
  alertUserOfDeprecatedProps('Tooltip', otherProps);
  var finalClasses = classnames(classes.root, _defineProperty({}, "--location-".concat(location), location), className);
  var tooltipContent = tooltip || content;
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses,
    "data-tooltip": tooltipContent,
    role: "tooltip",
    tabIndex: "0",
    "aria-label": tooltipContent
  }, otherProps));
};
Tooltip.displayName = 'Tooltip';

export { Tooltip as default };
